module.exports = __webpack_public_path__ + "static/media/git.8df07bef.png";